import React from "react";
import ReactDOM from "react-dom";
import registerServiceWorker from "./registerServiceWorker";
import "bootstrap/dist/css/bootstrap.css";
import RouterHandler from "./routerHandler";
import "./index.css";
import "./design/style.css";
import "./design/style_mobile.css";
import "./design/style_list.css";
import "react-phone-number-input/style.css";
import "react-responsive-ui/style.css";

ReactDOM.render(<RouterHandler />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js